/** @jsx jsx */

import { forwardRef } from 'react';
import { css, jsx } from '@emotion/react';
var baseStyles = css({
  display: 'flex',
  width: '100%',
  flexWrap: 'wrap'
});
var justifyStartStyles = css({
  justifyContent: 'flex-start'
});
var justifyEndStyles = css({
  justifyContent: 'flex-end'
});

/**
 * __Tag group__
 *
 * A tag group controls the layout and alignment for a collection of tags.
 *
 * - [Examples](https://atlassian.design/components/tag-group/examples)
 * - [Code](https://atlassian.design/components/tag-group/code)
 * - [Usage](https://atlassian.design/components/tag-group/usage)
 */
var TagGroup = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$alignment = _ref.alignment,
    alignment = _ref$alignment === void 0 ? 'start' : _ref$alignment,
    children = _ref.children;
  return jsx("div", {
    ref: ref,
    css: [baseStyles, alignment === 'start' && justifyStartStyles, alignment === 'end' && justifyEndStyles]
  }, children);
});
export default TagGroup;